import { z } from "zod";

export enum SmsMediaCategory {
  APPOINTMENT_DOCUMENT = "appointment_document",
  CLINICAL_PHOTO = "clinical_photo",
  IDENTITY_CARD = "identity_card",
  INSURANCE_CARD = "insurance_card",
  MEDICAL_DOCUMENT = "medical_document",
  OTHER = "other",
  SCREENSHOT = "screenshot",
}

export const smsMediaFactSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const smsMediaAnalysisResultSchema = z.object({
  attachments: z.array(
    z.object({
      category: z.nativeEnum(SmsMediaCategory),
      description: z.string(),
      facts: z.array(smsMediaFactSchema),
      index: z.number().int().nonnegative(),
      needsHumanReview: z.boolean(),
      readable: z.boolean(),
      transcription: z.string(),
    })
  ),
});

export const smsMediaAnalysisSchema = smsMediaAnalysisResultSchema.shape.attachments.element.extend({
  analyzedAt: z.string(),
  contentType: z.string(),
  model: z.string(),
});

export type SmsMediaAnalysis = z.infer<typeof smsMediaAnalysisSchema>;
export type SmsMediaAnalysisResult = z.infer<typeof smsMediaAnalysisResultSchema>;
